<template>
  <div class="sendtelegraph">
    <h1>
      <textarea
        type="text"
        name="title"
        maxlength="100"
        placeholder="请输入文章标题 (5~100个字)"
        v-model="getData.explainTitle"
      >
      </textarea>
      <span class="suffix">{{ getData.explainTitle.length }}/100</span>
    </h1>

    <div class="">
      <Textutil ref="myTinymce" @gettinymceHtml="htmlcontent" />
    </div>

    <div class="attributebox">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-item label="展示封面:" :required="true">
          <a-radio-group v-model="value" @change="onChangeRadio">
            <a-radio :value="1"> 单图 </a-radio>
            <a-radio :value="2"> 无封面 </a-radio>
          </a-radio-group>
        </a-form-item>

        <div class="clearfix" v-if="uploadBox">
          <a-upload
            :action="uploadFileUrl"
            list-type="picture-card"
            :file-list="fileList"
            :headers="headers"
            :before-upload="beforeUpload"
            :remove="removefile"
            @preview="handlePreview"
            @change="handleChangeUpload"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>

        <a-form-item label="文章标签:">
          <template v-for="(tag, index) in tags">
            <a-tooltip
              v-if="tag.length > 5"
              :key="index"
              :title="tag.labelName"
            >
              <a-tag
                :key="index"
                :closable="true"
                @close="() => handleClose(tag)"
                style="line-height: 2rem"
              >
                {{ `${tag.labelName.slice(0, 20)}...` }}
              </a-tag>
            </a-tooltip>
            <a-tag
              color="cyan"
              v-else
              :key="index"
              :closable="true"
              @close="() => handleClose(tag)"
              style="line-height: 2rem"
            >
              {{ tag.labelName }}
            </a-tag>
          </template>

          <a-dropdown
            v-model="tagBoxVisible"
            placement="topCenter"
            :trigger="['click']"
          >
            <a-button @click="ulstyleinit()"> + 添加标签 </a-button>
            <div slot="overlay">
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  width: 600px;
                  max-width: 600px;
                  height: 300px;
                  box-shadow: rgba(81, 83, 83, 0.795) 1px 1px 3px;
                  background-color: rgb(255, 255, 255);
                "
              >
                <!-- <div
                  style="
                    padding: 1rem;
                    width: 100%;
                    height: 68px;
                    background-color: rgb(255, 255, 255);
                  "
                >
                  <a-select
                    mode="tags"
                    style="width: 100%"
                    placeholder="查询标签"
                    allowClear
                    @change="onChangeTagInput"
                  >
                    <a-select-option
                      v-for="i in 25"
                      :key="(i + 9).toString(36) + i"
                    >
                      {{ (i + 9).toString(36) + i }}
                    </a-select-option>
                  </a-select>
                </div> -->
                <ul ref="ulstyle" style="height: 280px; overflow-y: auto">
                  <li
                    v-for="(items, index) in tagTreeData"
                    :key="index"
                    v-show="items.typeShow"
                    @click="selectTag(items.typeId)"
                    style="margin-top: 0.5rem; padding: 1rem"
                  >
                    <a>{{ items.typeName }}</a>
                  </li>
                </ul>
                <div style="padding: 1rem">
                  <span :style="{ marginRight: 10 }">添加标签</span>
                  <div style="margin-left: 1rem; margin-top: 0.5rem">
                    <template v-for="addtag in tagData">
                      <a-checkable-tag
                        ref="tagbox"
                        :key="addtag.labelId"
                        :checked="selectedTags.indexOf(addtag) > -1"
                        @change="(checked) => handleChange(addtag, checked)"
                        style="padding: 0.5rem; border: solid slategray 1px"
                      >
                        {{ addtag.labelName }}
                      </a-checkable-tag>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </a-dropdown>
        </a-form-item>

        <a-form-item label="分类专栏" :required="true">
          <a-cascader
            :options="options"
            :field-names="{
              value: 'id',
              label: 'sortName',
              children: 'children',
            }"
            :display-render="displayRender"
            expand-trigger="hover"
            change-on-select
            @change="onChangesort"
          />
          <!-- <a-input v-decorator="['parentId']" /> -->
        </a-form-item>

        <a-form-item label="文章类型:" :required="true">
          <a-select
            default-value="1"
            style="width: 120px"
            @change="handleChangeActualType"
          >
            <a-select-option value="1"> 原创 </a-select-option>
            <a-select-option value="2"> 转载 </a-select-option>
            <a-select-option value="3"> 翻译 </a-select-option>
          </a-select>
        </a-form-item>

        <div class="clearfix">
          <p v-if="complexA">
            <a-icon type="info-circle" />原创类型将启用<a
              target="_blank"
              href="https://creativecommons.org/licenses/by-sa/4.0/"
            >
              Creative Commons </a
            >版权模板，如果不是原创文章，请选择转载或翻译。
          </p>
          <div v-if="complexB">
            <a-input v-model="getData.sourceUrl" placeholder="请填写原文链接" />
            <a-checkbox @change="onChangeReprint">
              原文允许转载或本次转载已获得原文作者授权
            </a-checkbox>
          </div>
          <div v-if="complexC">
            <a-input v-model="getData.sourceUrl" placeholder="请填写原文链接" />
            <a-checkbox @change="onChangeReprint">
              原文允许翻译或本次翻译已获得原文作者授权
            </a-checkbox>
          </div>
        </div>

        <a-form-item label="发布形式:">
          <a-radio-group v-model="getData.status" @change="onChangeStatus">
            <a-radio :value="1"> 公开 </a-radio>
            <a-radio :value="0"> 私密 </a-radio>
            <a-radio :value="2"> 仅粉丝 </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <div class="buttonbox">
        <a-button @click="handleMenuClick"> 存稿 </a-button>
        <a-button type="primary" @click="handleMenuClick"> 发布 </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import text from "@/components/textutil/textutil.vue";

export default {
  name: "sendtelegraph",
  data() {
    return {
      explain: "",


      /**
       * 图片数据
       */
      uploadFileUrl: "",
      previewVisible: false,
      uploadBox: true,
      previewImage: "",
      headers: {
        oopvr: this.$store.state.index.token,
      },
      fileList: [],

      /**
       * 标签数据
       */
      tags: [],
      tagData: [{ labelId: 2, labelName: "java" }],
      selectedTags: [],
      temporaryTags: [],
      tagBoxVisible: false,
      tagTreeData: [{}],
      tagTypeId: "",
      /**
       * 分类数据
       */
      options: [{}],
      value: 1,

      complexA: true,
      complexB: false,
      complexC: false,

      getData: {
        explainTitle: "",
        content: "",
        coverFileUrl: "",
        taglist: [{}],
        tagTypeId: "",
        sortId: "",
        sourceUrl: "",
        sourceOk: false,
        actualType: 1,
        status: 1,
      },
    };
  },

  components: {
    Textutil: text,
  },
  mounted() {
    this.uploadFileUrl = this.$host + "/vr/upload/file/add";
    this.init();

  },
  methods: {

    htmlcontent(content) {
      console.log(content);
      this.getData.content = content;
    },
    handleMenuClick() {
      // console.log("click", e);
      console.log(this.getData);
      this.$postObject("/vr/netuser/content/add", this.getData)
        .then((response) => {
          if (response.code != 1) {
            return this.$message.error(response.data, 5);
          }
          this.$message.success(
            "提交" + this.getData.explainTitle + "成功！审核阶段。。。"
          );
           this.backBefor();
        })
        .catch((error) => {
          this.$message.error(error.data);
        });
    },

    /**
     * 发布形式
     */
    onChangeStatus(e) {
      this.getData.status = e.target.value;
    },

    /**
     * 封面选择
     */
    onChangeRadio(e) {
      e.target.value == 1 ? (this.uploadBox = true) : (this.uploadBox = false);
    },

    /**
     * 文章实际类型
     */
    handleChangeActualType(value) {
      this.getData.sourceUrl = "";
      switch (value) {
        case "1":
          this.complexA = true;
          this.complexB = false;
          this.complexC = false;
          break;
        case "2":
          this.complexA = false;
          this.complexB = true;
          this.complexC = false;
          break;
        case "3":
          this.complexA = false;
          this.complexB = false;
          this.complexC = true;
          break;
      }
      this.getData.actualType = value;
    },
    /**
     * 转载/翻译确定
     */
    onChangeReprint(e) {
      this.getData.sourceOk = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
        const isLt2M = file.size / 1024 / 1024 <= 2; //图片大小不超过5MB
        if (!testmsg) {
          this.$message.error("只能上传 JPG, JPEG, GIF 和 PNG 格式的图片喔!");
          return reject(false);
        }
        if (!isLt2M) {
          this.$message.error("上传图片的大小不能超过 2M!", 3);
          return reject(false);
        }
        return resolve(true);
      });
    },
    handleChangeUpload({ fileList }) {
      this.fileList = fileList;
      if (this.fileList[0].response) {
        this.getData.coverFileUrl = this.fileList[0].response.data.fileUrl;
      }

      // if (fileList[0].response.data) {
      //   let imagesMessage = {
      //     uid: fileList[0].response.data.fileId,
      //     name: fileList[0].response.data.fileName,
      //     status: fileList[0].response.data.filePosition,
      //     url: fileList[0].response.data.fileUrl,
      //   };
      //   this.fileList.push(imagesMessage);
      //   console.log(fileList[0].response.data);
      // }

      // console.log(this.fileList);
    },
    removefile(file) {
      console.log(file.response.data.fileEtag);
      this.$post("/vr/upload/file/delete", {
        etag: file.response.data.fileEtag,
      })
        .then((response) => {
          if (response.code != 1) {
            return this.$message.error(response.data, 5);
          }
          this.$message.success("删除" + file.name + "成功！");
        })
        .catch((error) => {
          this.$message.error(error.data);
        });
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    /**
     * 分类数据
     */
    init() {
      this.$get("/net/client/tag/type/select")
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.tagTreeData = this.getTagAllTreeList(response.data);
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
        });

      this.$get("/vr/netuser/sort/select")
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.options = this.getAllTreeList(response.data);
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
        });
    },

    //整理数据
    getAllTreeList(list) {
      list.map((item) => {
        if (item.hasOwnProperty("children") && item.children.length > 0) {
          this.getAllTreeList(item.children);
        }
        item.scopedSlots = { title: "sortName" };
        item.disabled = !item.sortDisplay;
        return item;
      });
      return list;
    },

    onChangesort(value) {
      this.getData.sortId = value[value.length - 1];
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },

    /**
     * 标签选择
     */

    getTagAllTreeList(list) {
      list.map((item) => {
        if (item.hasOwnProperty("children") && item.children.length > 0) {
          this.getTagAllTreeList(item.children);
        }
        item.scopedSlots = { title: "typeName" };
        item.disabled = !item.typeShow;
        return item;
      });
      return list;
    },
    selectTag(tagTypeIds) {
      this.getData.tagTypeId = tagTypeIds;
      if (this.tagTypeId == tagTypeIds) return;
      this.tagTypeId = tagTypeIds;
      this.tagBoxVisible = true;
      this.$post("/net/client/tag/select", { typeId: this.tagTypeId })
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.tagData = response.data;
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
        });
    },

    handleClose(removedTag) {
      const tags = this.tags.filter((tag) => tag !== removedTag);
      this.tags = tags;
    },

    handleChange(tag, checked) {
      const { selectedTags } = this;
      this.temporaryTags = checked
        ? [...selectedTags, tag]
        : selectedTags.filter((t) => t !== tag);

      // this.selectedTags = nextSelectedTags;
      this.selectedTags = this.$arrUnique(this.temporaryTags, "labelId");
      this.tags =
        selectedTags.length >= 5
          ? this.tags
          : JSON.parse(JSON.stringify(this.selectedTags));
    },

    ulstyleinit() {
      setTimeout(() => {
        if (!this.$refs.ulstyle.parentNode.classList.contains("tagchoicebox")) {
          this.$refs.ulstyle.parentNode.classList.add("tagchoicebox");
        }
        if (!this.$refs.ulstyle.classList.contains("topnav_box")) {
          this.$refs.ulstyle.classList.add("topnav_box");
        }
      }, 50);
      this.tagBoxVisible = false;
    },
    // onChangeTagInput(e) {
    //   console.log(e.target.value + "-----查询标签的内容");
    // },
  },

  watch: {
    tagBoxVisible(val, oldVal) {
      if (val) {
        return (this.temporaryTags = []), (this.selectedTags = []);
      }
      if (!val) {
        this.getData.taglist = this.tags;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sendtelegraph {
  padding-top: 2rem;
  width: 100%;
  min-height: 800px;
  background-color: rgb(255, 255, 255);
  h1 {
    width: 80%;
    // padding-bottom: 1rem;
    margin-left: 1rem;
    margin-bottom: 1.5rem;
    border-bottom: rgba(255, 255, 255, 0.76) solid 1px;
    textarea {
      border: none;
      width: 100%;
      vertical-align: top;
      outline: none;
      resize: none;
    }
    .suffix {
      position: relative;
      right: -100%;
      user-select: none;
      color: rgba(97, 95, 95, 0.781);
      font-size: 16px;
    }
  }
  .textbox {
    margin-top: 2rem;
  }
  .attributebox {
    // background-color: rgba(210, 250, 165, 0.788);
    margin-top: 1rem;
    width: 100%;
    min-height: 300px;
    padding-bottom: 2%;

    .buttonbox {
      text-align: center;

      margin: 0 auto;
      button:first-child {
        margin-right: 10px;
      }
      button:last-child {
        margin-left: 10px;
      }
    }
    /deep/ .ant-popover-inner-content {
      display: inline;
      position: relative;
      top: -25px;
      left: 80%;
    }
  }
  .clearfix {
    display: flex;
    margin-top: -2%;
    margin-left: 25%;
    a {
      color: rgb(30, 139, 240);
    }
  }
}

/* 滚动条出现不出现 当摸个滚动条不想让出现是可以这样*/
// #content_right::-webkit-scrollbar {
//     display: none;
// }   /*样式改变代码-----------------------------------------------------*/
/* 滚动条整体部分 */
.topnav_box::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #d0cdc7;
}
/* scroll轨道背景 */
.topnav_box::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(148, 211, 219, 0.767);
  border-radius: 10px;
  background-color: #ffffff0c;
}

/* 滚动条中能上下移动的小块 */
.topnav_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(118, 201, 202, 0.842);
  background-color: #8febf1;
}
/*样式改变代码-----------------------------------------------------*/
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/sendtelegraph.vue